/**
 * Интерфейс AI модели для использования в UI
 */
export interface AIModel {
  id: string;
  name: string;
  description: string;
  provider?: string;
  channel?: 'chat' | 'image' | 'video';
  contextWindowTokens?: number;
}

/**
 * DTO для AI модели из backend (AIPricing)
 */
export interface AIPricing {
  name: string;
  codeName: string;
  provider: string;
  inputPrice: number;
  outputPrice: number;
  marginality: number;
  isAvailable: boolean;
}

/**
 * DTO для Conversation из backend
 */
export interface ConversationResponseDTO {
  id: number;
  userId: number;
  telegramId: number;
  conversationAiId: string;
  title: string;
  provider: string;
  isActive: boolean;
  isDeleted: boolean;
  createdAt: string;
  lastUsedAt: string;
}

export interface ConversationMessageResponseDTO {
  id: number;
  clientMessageId?: string | null;
  providerResponseId?: string | null;
  role: string;
  status: string;
  content: string;
  sequenceNumber: number;
  replyToMessageId?: number | null;
  regenerationGroupId?: string | null;
  regeneratedFromMessageId?: number | null;
  provider?: string | null;
  modelId?: string | null;
  generationSource?: string | null;
  inputTokens?: number | null;
  outputTokens?: number | null;
  totalTokens?: number | null;
  createdAt: string;
  completedAt?: string | null;
   steps?: Array<{
    stepIndex: number;
    phase: string;
    status: string;
    text?: string | null;
    startedAt?: string;
    completedAt?: string;
    durationMs?: number;
    callingLlmMs?: number | null;
    executingToolsMs?: number | null;
    reasoningText?: string | null;
    reasoningMs?: number | null;
  }>;
  parts?: Array<{
    id: number;
    messageId: number;
    position: number;
    type: string; // MEDIA, TEXT...
    stepIndex?: number;
    phase?: string;
    text?: string | null;
    url?: string | null;
    urlExpiresAt?: string;
    meta?: {
      kind: 'IMAGE' | 'VIDEO' | string;
      mimeType?: string;
      widthPx?: number | null;
      heightPx?: number | null;
      sizeBytes?: number;
      title?: string | null;
      sourceUrl?: string | null;
    };
  }>;
  tools?: Array<{
    toolCallId: string;
    toolName: string;
    status: string;
    step: number;
    resultJson?: string | null;
    errorMessage?: string | null;
  }>;
}

export interface ConversationMessagesPageDTO {
  items: ConversationMessageResponseDTO[];
  hasMore: boolean;
  nextBeforeSequence?: number | null;
}

/**
 * Fallback модели на случай, если API недоступно
 */
export const AI_MODELS: AIModel[] = [
  { id: "gpt-4.1", name: "GPT-4.1", description: "Самая мощная модель" },
  { id: "gpt-4o", name: "GPT-4o", description: "Быстрая и эффективная" },
  { id: "gpt-5.1", name: "Claude 3", description: "Хорошо для длинных текстов" },
  { id: "gemini", name: "Gemini Pro", description: "От Google" }
];

